import { ReactNode } from "react";
import { useNotification as useNotificationContext } from "../contexts/NotificationContext";

export const useNotification = () => {
  const { addNotification, clearNotifications } = useNotificationContext();

  const notify = (
    type: "success" | "error" | "info",
    message: ReactNode, // Changed from string to ReactNode
    duration?: number,
  ) => {
    addNotification(type, message, duration);
  };

  return { notify, clearNotifications };
};

// Export the old notify function for backward compatibility
export const notify = () => {
  // This will be replaced by the context-based system
  // eslint-disable-next-line no-console
  console.warn(
    "Using deprecated notify function. Please use useNotification hook instead.",
  );
};
